import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorRegularInvestigation from './doctor-regular-investigation';
import DoctorRegularInvestigationDetail from './doctor-regular-investigation-detail';
import DoctorRegularInvestigationUpdate from './doctor-regular-investigation-update';
import DoctorRegularInvestigationDeleteDialog from './doctor-regular-investigation-delete-dialog';

const DoctorRegularInvestigationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorRegularInvestigation />} />
    <Route path="new" element={<DoctorRegularInvestigationUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorRegularInvestigationDetail />} />
      <Route path="edit" element={<DoctorRegularInvestigationUpdate />} />
      <Route path="delete" element={<DoctorRegularInvestigationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorRegularInvestigationRoutes;
